var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAutodesk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.086084 13.9714L9.88325 7.87698H14.9659C15.0049 7.87698 15.0435 7.88464 15.0797 7.89959C15.1154 7.91455 15.1482 7.93644 15.176 7.96416C15.2033 7.99188 15.2252 8.02471 15.2402 8.06082C15.2551 8.09657 15.2624 8.13523 15.2624 8.17426C15.2664 8.22496 15.2555 8.27566 15.2307 8.32017C15.2062 8.36467 15.169 8.40041 15.1238 8.42376L10.3118 11.309C9.99924 11.4962 9.88945 11.8719 9.88945 12.1531L9.88471 13.9714H16V3.40462C16.0003 3.35392 15.9901 3.30358 15.97 3.25726C15.9504 3.21057 15.9215 3.16826 15.8847 3.13324C15.8482 3.09822 15.8052 3.07086 15.7578 3.05263C15.7103 3.03475 15.6596 3.02673 15.6089 3.02892H9.77382L0 9.09711V13.9714H0.086084Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAutodesk);
export default __webpack_public_path__ + "static/media/icon--autodesk.ba79e4ec80bfdba7fdcbfc77827d8f7f.svg";
export { ForwardRef as ReactComponent };